import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from "react";
import { reaction } from "mobx";
import { convertToRaw } from "draft-js";
import { createStore, components } from "@reactivepad/core";
export { createStore };
var Formula = components.Formula,
    Table = components.Table;
export var ENTITY_TYPES = {
  FORMULA: "reactivepad_formula",
  TABLE: "reactivepad_table"
}; // ToDo: extract and reuse this function across all plugins

var syncStoreWithDoc = function syncStoreWithDoc(store, editorState) {
  var _convertToRaw = convertToRaw(editorState.getCurrentContent()),
      entityMap = _convertToRaw.entityMap;

  var nodes = entityMap && Object.values(entityMap).map(function (_ref) {
    var data = _ref.data;
    return data;
  }) || [];
  nodes.forEach(function (props) {
    var id = props.id,
        restProps = _objectWithoutProperties(props, ["id"]);

    var node = store.findById(id);

    switch (props.type) {
      case "formula":
        {
          if (node) {
            node.setProps(restProps);
          } else {
            store.createAndAddFormula(props);
          }

          break;
        }

      default:
        break;
    }
  });
  store.nodes.filter(function (node) {
    return !nodes.some(function (_ref2) {
      var id = _ref2.id;
      return id === node.id;
    });
  }).forEach(function (node) {
    store.removeNode(node);
  });
};

export { syncStoreWithDoc };
export function getEntityStrategy(type) {
  return function (contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(function (character) {
      var entityKey = character.getEntity();

      if (entityKey === null) {
        return false;
      }

      return contentState.getEntity(entityKey).getType() === type;
    }, callback);
  };
}
export var formulaDecoratorStrategy = getEntityStrategy(ENTITY_TYPES.FORMULA);
export function FormulaView(props) {
  var contentState = props.contentState,
      entityKey = props.entityKey,
      updateContentState = props.updateContentState,
      children = props.children,
      store = props.store;
  var data = contentState.getEntity(entityKey).getData();
  var node = store.findById(data.id) || store.createAndAddFormula(data); // ToDo: syncStore fn should handle creation

  var onSnapshot = function onSnapshot(snapshot) {
    var newContentState = contentState.replaceEntityData(entityKey, snapshot);
    updateContentState(newContentState, true);
  };

  return React.createElement("span", {
    contentEditable: false
  }, React.createElement(Formula, {
    node: node,
    onSnapshot: onSnapshot
  }), React.createElement("span", {
    style: {
      display: "none"
    }
  }, children));
}
export function TableView(props) {
  var block = props.block,
      contentState = props.contentState,
      updateContentState = props.updateContentState,
      _props$toggleReadOnly = props.toggleReadOnly,
      toggleReadOnly = _props$toggleReadOnly === undefined ? function () {} : _props$toggleReadOnly,
      offsetKey = props.offsetKey,
      store = props.store;
  var entityKey = block.getEntityAt(0);
  var entity = contentState.getEntity(entityKey);
  var data = entity.getData();
  var node = store.findById(data.id) || store.createAndAddFormula(data); // ToDo: syncStore fn should handle creation

  var onSnapshot = function onSnapshot(snapshot) {
    var newContentState = contentState.replaceEntityData(entityKey, snapshot);
    updateContentState(newContentState, true);
  };

  return React.createElement("div", {
    "data-offset-key": offsetKey,
    onFocus: function onFocus() {
      return toggleReadOnly(true);
    },
    onBlur: function onBlur() {
      return toggleReadOnly(false);
    }
  }, React.createElement(Table, {
    node: node,
    onSnapshot: onSnapshot
  }));
}
export var buildPlugin = function buildPlugin() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$store = _ref3.store,
      store = _ref3$store === undefined ? createStore() : _ref3$store,
      _ref3$toggleReadOnly = _ref3.toggleReadOnly,
      toggleReadOnly = _ref3$toggleReadOnly === undefined ? function () {} : _ref3$toggleReadOnly;

  var reactionDisposer = reaction(function () {
    return store.isSomeNodeEditing;
  }, function () {
    toggleReadOnly(store.isSomeNodeEditing);
  }, {
    fireImmediately: false
  });
  return {
    store: store,
    components: {
      Formula: function Formula(props) {
        return React.createElement(FormulaView, _extends({}, props, {
          store: store
        }));
      },
      Table: function Table(props) {
        return React.createElement(TableView, _extends({}, props, {
          store: store,
          toggleReadOnly: toggleReadOnly
        }));
      }
    },
    destroy: function destroy() {
      reactionDisposer();
    }
  };
};